import { useFloatingPortalNode } from '@floating-ui/react';
import { createPortal } from 'react-dom';
import { PORTAL_ID, TOAST_PORTAL_ID } from '.';
import { PortalNodeContainer } from './styled';
export function Portal(props) {
    const { children, isToast = false } = props;
    const id = isToast ? TOAST_PORTAL_ID : PORTAL_ID;
    const portalNode = useFloatingPortalNode({ id });
    if (portalNode) {
        return createPortal(<PortalNodeContainer>{children}</PortalNodeContainer>, portalNode);
    }
    return null;
}
